import { User } from './api';

/**
 * Determines if a user is considered a premium subscriber based on their plan status and gateway.
 * For Cashfree:
 * - Amount > ₹5 indicates a full plan payment was initiated.
 * - Amount <= ₹5 indicates a verification charge, considered premium if status is not 'failed'.
 * For other gateways (Razorpay, Google Play):
 * - Uses the isPremiumPlan flag or presence of a plan historyId.
 */
export const isPremiumUser = (user?: User | null): boolean => {
    if (!user) return false;

    const plan = user.plan;
    // const subDetails = plan?.subscriptionDetails;

    // // Handle Cashfree specific redirection/status logic
    // if (subDetails?.paymentGateway?.toLowerCase() === 'cashfree') {
    //     const amount = subDetails.amount || 0;
    //     const status = plan?.status;

    //     if (amount > 5) {
    //         return true;
    //     } else if (status !== 'failed') {
    //         return true;
    //     }
    //     return false;
    // }

    // Standard check for other gateways
    return !!(user.isPremiumPlan || plan?.historyId);
};
